// Kebijakan cache bacaan `site_settings` — helper MURNI (tanpa Supabase/DOM).
//
// Audit PROD 2026-10-30 (edge_logs 07:00–15:50 WIB): `site_settings` 12.679
// request — server Next 3.873 (appearance 1.430 · pixel 1.091 · branding 854 ·
// sisanya ±500), browser 8.806 (`fetchSiteSettings` 2.918 dari 354 sesi,
// `wa_message_templates` 1.832 dari 296 sesi, GET + preflight OPTIONS). Datanya
// jarang berubah, jadi pembaca server diperpanjang — DENGAN invalidasi saat admin
// menyimpan, bukan TTL saja.

/** Revalidate (detik) pembaca REST server yang membaca `site_settings` untuk
 *  storefront. Sebelumnya 120 (appearance, pixel, waTemplates) dan 300
 *  (branding). Invalidasi per-tag (di bawah) membuat penyimpanan admin tampil
 *  seketika; angka ini hanya batas atas untuk jalur yang TAK sampai ke route
 *  invalidasi — admin di proses Hostinger lain (PROD = dua website), penulisan
 *  lewat panel platform, atau SQL langsung. */
export const SERVER_SETTINGS_REVALIDATE_S = {
  appearance: 600,
  pixel: 600,
  branding: 600,
  waTemplates: 600,
} as const;

/** TTL cache memori klien. */
export const CLIENT_SETTINGS_TTL_MS = {
  /**
   * `fetchSiteSettings` SENGAJA tetap 60 dtk. Rencana awal 5 menit digugurkan
   * pemeriksaan 2026-10-30: biaya Dropship/Packing (`dropshipFeeAmount`) dibaca
   * dari cache ini oleh layar ACC (`AdminInvoiceDetail.tsx`) lalu DIKIRIM KLIEN
   * sebagai baris `manual` ke `approve_invoice` — angkanya tidak dihitung ulang
   * server di jalur itu. TTL panjang berarti nota bisa terbit dengan biaya lama.
   */
  siteSettings: 60_000,
  /** Template WhatsApp: teks saja, tak menyentuh uang. */
  waTemplates: 600_000,
} as const;

/** Tag cache Next untuk SEMUA bacaan server `site_settings` satu toko. Satu tag
 *  per toko (bukan per pembaca): menyimpan setelan apa pun cukup membuang
 *  keempatnya — kelebihan buang tak berbahaya, ketinggalan buang yang berbahaya. */
export function siteSettingsTag(storeId: string): string {
  return `site-settings:${storeId}`;
}

export const SITE_SETTINGS_REVALIDATE_ENDPOINT =
  "/api/admin/revalidate-site-settings";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** `storeId` yang boleh masuk ke tag/URL: hanya UUID. Pembaca REST menyusun URL
 *  dengan string-concat, jadi nilai liar tak boleh sampai ke sana. */
export function isValidStoreId(storeId: unknown): storeId is string {
  return typeof storeId === "string" && UUID_RE.test(storeId);
}

/**
 * Admin boleh membuang cache toko ini hanya bila toko pada Host request SAMA
 * dengan toko profilnya. Admin toko A yang menembak Host toko B tidak boleh
 * menyapu cache B; toko tak ter-resolusi → tidak ada yang dibuang.
 */
export function mayRevalidateStore(args: {
  hostStoreId: string | null;
  profileStoreId: string | null;
}): boolean {
  if (!isValidStoreId(args.hostStoreId)) return false;
  if (!isValidStoreId(args.profileStoreId)) return false;
  return args.hostStoreId.toLowerCase() === args.profileStoreId.toLowerCase();
}
